<template lang="pug">
BriqDialog(@close="closeDialog")
  .form
    div(v-if="showSaveForm")
      label.margin-r-10 Enter link:
      .inline-block-input
        BriqInput(v-model="linkHref")
      BriqButton(
        variant="text"
        :small="true"
        @click="saveLink"
        ) Save
    div(v-else)
      label.margin-r-20 Visit URL: 
        a.margin-l-10(
          :href="linkHref"
          target="_blank"
          ) {{ linkHref }}
      BriqButton(
        variant="text"
        :small="true"
        @click="editLink"
        ) Edit
      BriqButton(
        variant="text"
        :small="true"
        @click="removeLink"
        ) Remove
</template>

<script>
import BriqButton from './BriqButton.vue'
import BriqInput from './BriqInput.vue'
import BriqDialog from './BriqDialog.vue'

export default {
  name: 'BriqRichEditorLinkPopup',
  components: {
    BriqButton,
    BriqInput,
    BriqDialog
  },
  props: {
    showSaveForm: Boolean,
    inputLinkValue: String,
  },
  data() {
    return {
      linkHref: ''
    }
  },
  watch: {
    inputLinkValue(newVal) {
      this.linkHref = newVal
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    saveLink() {
      this.$emit('saveLink', this.linkHref)
      this.linkHref = ''
    },
    editLink() {
      this.$emit('editLink')
    },
    removeLink() {
      this.linkHref = ''
      this.$emit('removeLink')
    }
  }
}
</script>


<style scoped lang="stylus">
.form
  text-align center

  a
    text-decoration none

.margin-r-20
  margin-right 20px

.margin-r-10
  margin-right 10px

.margin-l-10
  margin-left 10px

.inline-block-input
  display inline-block
  width auto

  .briq-input
    margin-bottom 0
</style>
